import styled from "styled-components";
import { Heading1, SubHeading, CTAButtonWrapper } from "../../../../../landing-pages/js/common/styled-components/styled-components";
import { white, deepCoveDark, black } from '../../../components/loggedout/shared-styles/Colors';
import { breakpoints, device } from "../../../utils/responsive_utilities";
import { styledFont } from '../../../../../landing-pages/js/common/mixins/mixin';


export const ContainerWrapper = styled.div`
    width:100%;
    height:100%;
    background-color: ${deepCoveDark};
    padding-top: 7.7rem;
    position: relative;
    ${styledFont("Graphie")};

    @media (min-width: ${breakpoints.md}px){
        padding-top: 0;
        flex-direction: row;
    }
    @media ${device.TabletLandscape}, ${device.Tablet},${device.PhoneTabletLandscape}{
      padding-top: 6.4rem;
    }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 144rem;
  margin: 0 auto;

  @media (min-width: ${breakpoints.md}px){
    flex-direction: row;
  }
  @media ${device.Tablet}, ${device.TabletLandscape}{
    flex-direction: column;
  }
`

export const LeftContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    
    @media ${device.Desktop}{
      width: 50rem;
      padding: 23rem 0 10rem 7.5rem
    }

    @media ${device.TabletLandscape}{
      width: 100%;
      padding: 3.4rem 0 0 0;
      text-align: center;
    }

    @media ${device.Tablet}{
      width: 100%;
      padding: 6rem 4rem 0;
    }

    @media ${device.PhoneTabletLandscape}{
      padding: 6rem 0 0 0;
    }

`

export const RightContainer = styled.div`
    width: 100%;
    height: 24.7rem;
    margin: auto;
    position: relative;

    @media ${device.Desktop}{
      width: calc(100% - 50rem);
      height: auto;
      margin: unset;
    }
    
    @media ${device.TabletLandscape}{
      width: 62.9rem;
      height: 38.8rem;
      margin: auto;
    }
    @media ${device.Tablet}{
      width: 57.7rem;
      height: 35.6rem;
      margin: auto;
    }
    @media ${device.PhoneTabletLandscape}{
      width: 57.7rem;
      height: 38.1rem;
      margin: auto;
    }

`

export const ImgSection = styled.div`
  width: 100%;
  height: 100%;
  left: 0rem;
  bottom: -5rem;
  z-index: 3;
  position: absolute;

  >img:nth-child(1){
    width: 100%;
    height: 100%;
    position: relative;
  }
  @media ${device.Phone} {
    bottom: 0rem;
  }
  @media ${device.Desktop}{
    width: 92.4rem;
    height: 57.4rem;
    z-index: 1;
    top: 6rem;
  }
`

export const HeadingText = styled(Heading1)`
    ${styledFont("Graphie", 3.2, 3.6, 7)};
    width: 70%;
    margin: 1rem auto;
    @media (min-width: ${breakpoints.md}px){
        margin: 0.4rem auto 1.4rem 0;
        text-align: left;
        width: 100%;
        ${styledFont("Graphie", 4.4, 5.2, 7)};
    }

    @media ${device.Tablet}, ${device.TabletLandscape}, ${device.Phone}, ${device.PhoneTabletLandscape}{
      ${styledFont("Graphie", 3.2, 3.6, 7)};
      text-align: center;
    }    
    @media ${device.Phone}{
      width: 32.1rem;
    }
`
export const SubHeadingText = styled(SubHeading)`
  width: 80%;
  color: ${props => props.color ? props.color : black};
  text-align: ${props => props.textAlign ? props.textAlign : 'center'};
  ${props => styledFont("Graphie", 2, 2.4, (props.fontWeight ? props.fontWeight : 6))}

  @media ${device.Desktop}{
    ${props => styledFont("Graphie", 2, 2.4, (props.fontWeight ? props.fontWeight : 6))}
  }
  @media ${device.Tablet}, ${device.TabletLandscape}, ${device.Phone}, ${device.PhoneTabletLandscape}{
    width: 100%;
    text-align: center;
    ${props => styledFont("Graphie", 1.6, 2, (props.fontWeight ? props.fontWeight : 6))}
  } 

  @media ${device.Phone}{
    width: 60%;
    margin: auto;

  }
`

export const IconsContainer = styled.div`
    display:flex;
`

export const ButtonWrapper = styled(CTAButtonWrapper)`
  width: 100%;
  >div {
    width: 25.2rem;
  }  
    
  margin-top: 2.4rem;

  @media (min-width: ${breakpoints.md}px){
    justify-content: left;
  } 
  @media ${device.Tablet}, ${device.TabletLandscape}, ${device.Phone}, ${device.PhoneTabletLandscape}{
    >div {
      margin: auto;
    }
  }
`
export const KidSafe = styled.div`
  width: 7.4rem;
  height: 2.7rem;
  margin: 2.9rem auto auto auto;
  > img{
    width: 100%;
    height: 100%;
  }

  @media ${device.Desktop} {
    margin: auto;
    > img{
      width: 9.5rem;
      height: 3.4rem;
    }
  }
`
export const BottomSection = styled.div`
  background-color: ${white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2;
  position: relative;
`

export const BottomWave = styled.div`
  z-index: 2;
  position: relative;
  >img{
    width: 100%;
    height: 100%;
    display: block;
  }
`
export const BottomHeadingText = styled.h2`
  text-align: center;
  color: ${black};
  ${styledFont("Graphie", 3.2, 3.6, 7)};
  margin: 0.8rem 0;
  @media (min-width: ${breakpoints.md}px){     
    ${styledFont("Graphie", 4.4, 5.2, 7)};
  }

  @media ${device.Tablet}, ${device.TabletLandscape}, ${device.Phone}, ${device.PhoneTabletLandscape}{
    ${styledFont("Graphie", 2.8, 3.2, 7)};
  }    
`
export const StarContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: none;
  @media ${device.Desktop}{
    display: block;
    >span:nth-of-type(1){
      top: 13rem;
      left: 17rem;
    }
    >span:nth-of-type(2){
      top: 10rem;
      left: 64rem;
    }
    >span:nth-of-type(3){
      top: 52rem;
      left: 54rem;
    }
    >span:nth-of-type(4){
      top: 12rem;
      right: 23rem;
    }
    >span:nth-of-type(5){
      top: 23rem;
      left: 86.5rem;
    }
    >span:nth-of-type(6){
      display: none;
    }
  }

  @media ${device.TabletLandscape}{
    display: block;
    >span:nth-of-type(1){
      top: 4.8rem;
      left: 13rem;
    }
    >span:nth-of-type(2){
      top: 1rem;
      left: 90rem;
    }
    >span:nth-of-type(3){
      top: 16rem;
      left: 24rem;
    }
    >span:nth-of-type(4){
      top: 39rem;
      left: 14rem;
    }
    >span:nth-of-type(5){
      top: 23rem;
      left: 86.5rem;
    }
    >span:nth-of-type(6){
      top: 41rem;
      left: 81rem;
    }
  }

  @media ${device.Tablet}{
    display: block;
    >span:nth-of-type(1){
      top: 8rem;
      left: 3rem;
    }
    >span:nth-of-type(2){
      top: 3rem;
      left: 49rem;
    }
    >span:nth-of-type(3){
      top: 25rem;
      left: 17rem;
    }
    >span:nth-of-type(4){
      top: 18rem;
      left: 69rem;
    }
    >span:nth-of-type(5){
      top: 45rem;
      left: 5rem;
    }
    >span:nth-of-type(6){
      top: 51rem;
      left: 71rem;
    }
  }

  @media ${device.PhoneTabletLandscape}{
    display: block;
    >span:nth-of-type(1){
      top: 8rem;
      left: 3rem;
    }
    >span:nth-of-type(2){
      top: 3rem;
      left: 49rem;
    }
    >span:nth-of-type(3){
      top: 25rem;
      left: 17rem;
    }
    >span:nth-of-type(4){
      top: 18rem;
      left: 69rem;
    }
    >span:nth-of-type(5){
      top: 45rem;
      left: 5rem;
    }
    >span:nth-of-type(6){
      top: 51rem;
      left: 71rem;
    }
  }

`
export const Star = styled.span`
  position: absolute;
  z-index: 100;
  width: 0.8rem;
  height: 0.9rem;
`;
